import { render } from "./MindUpMatchAudioTable.vue?vue&type=template&id=1c6fb99a&scoped=true&ts=true"
import script from "./MindUpMatchAudioTable.vue?vue&type=script&lang=ts"
export * from "./MindUpMatchAudioTable.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6fb99a"]])

export default __exports__